import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { SeparatorPipe } from '../../pipes/separator.pipe';

@Component({
  selector: 'la-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule, ClipboardModule, SeparatorPipe],
})
export class CopyToClipboardComponent implements OnDestroy {
  @Input() value?: string | string[] | string[][];

  readonly status = signal(false);
  private copiedTimeout: ReturnType<typeof setTimeout> | null = null;

  private readonly CHANGE_AFTER = 700;

  ngOnDestroy(): void {
    if (this.copiedTimeout) {
      clearTimeout(this.copiedTimeout);
    }
  }

  onCopy() {
    this.status.set(true);

    if (this.copiedTimeout) {
      clearTimeout(this.copiedTimeout);
    }

    this.copiedTimeout = setTimeout(() => {
      this.status.set(false);
      this.copiedTimeout = null;
    }, this.CHANGE_AFTER);
  }
}
